import { useMutation } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { toast } from 'react-hot-toast'

const userVoiceIntegrityKeys = {
  all: ['userVoiceIntegrity'],
  details: (id: number) => [...userVoiceIntegrityKeys.all, id],
}

const fetchUserVoiceIntegrity = async (id: number) => {
  const response = await fetch(
    `${BASE_API_URL}/api/v3/phone_numbers/voice_integrity`,
    {
      method: API_METHODS.POST,
      headers: apiHeaders(store.getState()),
      body: JSON.stringify({
        user_id: id,
      }),
    }
  )
  const json = await response.json()
  if (json.error) {
    if (json.error.includes('already assigned')) {
      throw new Error('Phone number already assigned to all Trust Products')
    }
    throw new Error(json.error)
  }
  return json
}

const useUserVoiceIntegrity = (id: number) => {
  return useMutation(() => fetchUserVoiceIntegrity(id), {
    onSuccess: () => {
      toast.success('User voice integrity assigned successfully')
    },
    onError: (error: any) => {
      toast.error(error.message || 'Failed to assign user voice integrity')
    },
  })
}

export default useUserVoiceIntegrity
